import JSPM               from 'jsprintmanager'

JSPM.JSPrintManager.auto_reconnect = true;
JSPM.JSPrintManager.start();
import fmt                   from '@/components/mixins/fmt.js'
export default {
    mixins : [fmt],
    data () {
        return {
        
            btn : JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open
       
        }
      },

  methods:{  

async printPreviewReceipt(data)
  {
     
    const items      = data.cart
    const total      = data.total
    const discount   = data.discount
    const storeId    = data.storeId
    const deskId     = data.deskId
    const percentage = data.percentage
    const text = await this.getReceiptHeading(storeId,deskId)
    const headerText = text.filter(item=>item.type == 'H')
    // const footerText = data.filter(item=>item.type == 'F')

     function jspmWSStatus() {
        if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open)
            return true;
        else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Closed) {
            alert('JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm');
            return false;
        }
        else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Blocked) {
            alert('JSPM has blocked this website!');
            return false;
        }
    }

    const pad     = ' '  
    const GS      = '\x1d'  
    const esc     = '\x1B'; //ESC byte in hex notation
    const newLine = '\x0A'; //LF byte in hex notation

    var cmds = esc + "@"; //Initializes the printer (ESC @)
    var cols = 48
      
    
        headerText.forEach(row =>{
    
        if(row.order_by == 1)
        {   
            cols = row.cols   
                      
            cmds += esc + 'a' + '\x01'
            cmds += esc + '!' + '\x38'; //Emphasized + Double-height + Double-width mode selected (ESC ! (8 + 16 + 32)) 56 dec => 38 hex
            cmds += row.text  //text to print
            cmds += newLine
            
            
        }
        else
        {
            /*
            cmds += esc + '!' + '\x00'; //Character font A selected (ESC ! 0)
            cmds += row.text  //text to print
            cmds += newLine;
            */
        }
        
            cmds += esc + '!' + '\x00'; //Character font A selected (ESC ! 0)

    })
          
    cmds += newLine
    cmds += 'PRECONTO DEL ' + this.fmtDate() + newLine
    cmds += newLine


    let spc = cols - 15
    

    cmds += GS + '!' +  '\x01' //Emphasized + Double-height + Double-width mode selected (ESC ! (8 + 16 + 32)) 56 dec => 38 hex
    cmds += 'DESCRIZIONE' + pad.repeat(spc) + 'EURO'   //text to print
        
    cmds += newLine
    cmds += newLine
        
    cmds += esc + '!' + '\x00'; //Character font A selected (ESC ! 0)
    
    // BODY
    items.forEach(item => {
        
        const retail_price = this.fmt1(item.price)
        const rowTotal     = this.fmt1(item.rowTotal)
        const discount     = item.discount
        let discount_val = 0
        
        if(item.rowTotal < 0)
        {
            discount_val = item.price - (item.rowTotal * -1)
        }
        else
        {
            discount_val = item.price - item.rowTotal
        }    
        
        const product = item.barcode + ' ' +  item.category                         
        spc = cols - product.length - retail_price.length          
        cmds += product + pad.repeat(spc) +  retail_price   //text to print
        cmds += newLine
        
        if(discount > 0)
        {    
            const description1 = 'SCONTO ' + discount + '%   ' + this.fmt1(discount_val) 
            spc = cols - description1.length - rowTotal.length
            cmds += description1 + pad.repeat(spc) + rowTotal   //text to print
            cmds += newLine
            cmds += newLine
        }
          
    })

    cmds += newLine;
   
   
    if(discount != '0.00')
    {
        const subTotal = this.fmt1(total)      
        spc = cols - 10 -  subTotal.length
        cmds += 'SUBTOTALE' + ' ' + pad.repeat(spc) + subTotal   //text to print
        cmds += newLine;      
    }
    

    if(discount != '0.00')
      {
        const percent = percentage
        const total = this.fmt1(discount)      
        const description2 = 'SCONTO CASSA ' + percent + '%'  
        spc = cols - description2.length - total.length -1
        cmds += description2  +  pad.repeat(spc) + '-' + total   //text to print
        cmds += newLine;      
      }
      

    const grandTotal  = this.fmt1(total - discount)
    cmds += GS + '!' +  '\x01'
    spc = cols - 12 - grandTotal.length
    cmds += 'TOTALE EURO ' + pad.repeat(spc) +  grandTotal   //text to print
    cmds += newLine
    cmds += newLine
    cmds += esc + '!' + '\x00'; //Character font A selected (ESC ! 0)


    const tot_items = items.length
    spc = cols - 15 - tot_items.toString().length
    cmds += 'TOTALE ARTICOLI' + pad.repeat(spc) +  tot_items   //text to print
    cmds += newLine
    cmds += newLine
    
    cmds += newLine
  
   
    
    cmds += newLine
    cmds += newLine
    cmds += newLine
    cmds += newLine
    cmds += newLine
    cmds += GS + 'V' + '\x01'   
    cmds += newLine
    
  
    if (jspmWSStatus()) {
            //Create a ClientPrintJob
            var cpj = new JSPM.ClientPrintJob();
            cpj.clientPrinter = new JSPM.DefaultPrinter();
            
            /*
            //Set Printer type (Refer to the help, there many of them!)
            if ($('#useDefaultPrinter').prop('checked')) {
                cpj.clientPrinter = new JSPM.DefaultPrinter();
            } else {
                cpj.clientPrinter = new JSPM.InstalledPrinter($('#installedPrinterName').val());
            }
            */
           

            cpj.printerCommands = cmds;
            //Send print job to printer!
            cpj.sendToClient();
            

     }


    }
}
}